'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const jsxRuntime = require('react/jsx-runtime');
const reactAriaComponents = require('react-aria-components');

const ModalDialogTrigger = ({ children }) => {
  return jsxRuntime.jsx(reactAriaComponents.DialogTrigger, { children });
};

exports.ModalDialogTrigger = ModalDialogTrigger;
//# sourceMappingURL=Trigger.cjs.js.map
